import { Component, input } from '@angular/core';
import { Organizacja } from '../../models/organizacja';
import { PreviewDataWrapperComponent } from '../preview-data-wrapper/preview-data-wrapper.component';

@Component({
  selector: 'app-preview-contact',
  imports: [PreviewDataWrapperComponent],
  templateUrl: './preview-contact.html',
  styleUrl: './preview-contact.scss',
})
export class PreviewContact {
  public readonly organization = input<Organizacja>();
}
